import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from './BaseOptionChart';

var pt = require("apexcharts/dist/locales/pt.json");


const CHART_DATA = [
    {name: 'Correções',
        data: [
            {
            x: '01/01/2022',
            y: 40,
            goals: [
                {
                name: 'Alertas',
                value: 100,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
            ]
            },
            {
            x: '02/01/2022',
            y: 60,
            goals: [
                {
                name: 'Alertas',
                value: 80,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
            ]
            },
            {
            x: '03/01/2022',
            y: 70,
            goals: [
                {
                name: 'Alertas',
                value: 120,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
            ]
            },
            {
            x: '04/01/2022',
            y: 45,
            goals: [
                {
                name: 'Alertas',
                value: 50,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
            ]
            },
            {
            x: '05/01/2022',
            y: 110,
            goals: [
                {
                name: 'Alertas',
                value: 130,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
            ]
            },
            {
            x: '06/01/2022',
            y: 67,
            goals: [
                {
                name: 'Alertas',
                value: 90,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#FF4842'
                }
                ]
            }
        ]
    }
];

export default function TaxaCorrecaoPostura() {

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
        height: 350,
        type: 'bar',
        locales: [pt],
        defaultLocale: 'pt',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '80%',
            borderRadius: 4
        }
      },
      xaxis: { 
        type: 'datetime',
        /*
        labels: {
            format: 'dd/MM'
          }*/
      },
      colors: ['#358A8B'],
      dataLabels: {
          enabled:true,
          style: {
            fontSize: '12.5px',
            //fontFamily: 'Helvetica, Arial, sans-serif',
            //fontWeight: 'bold',
        },
        formatter: function(val, opt) {
          const goals =
            opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
              .goals
      
          if (goals && goals.length) {
            return `${Math.round((val/goals[0].value)*100)} %`
            //return `${val/goals[0].value} %`
          }
          return val
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: ['N.º de Correções','N.º de Alertas'],
        markers: {
          fillColors: ['#358A8B','#FF4842']
        }
      }
  });

  return (
    <Card>
      <CardHeader title="Taxa de Correção da Postura Corporal" />{/*subheader="(+43%) que no ano passado" />*/}
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={250} />
      </Box>
    </Card>
  );
}
